var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaleIlusGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 81,
    height: 81,
    rx: 40.5,
    fill: "#74BE00"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 81,
    height: 81,
    rx: 40.5,
    stroke: "#E6FFBF",
    strokeWidth: 13.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.8334 65.8333C42.5001 65.8333 41.3334 65.3333 40.5001 64.5L31.0001 55C29.0001 53 29.1668 49.6667 31.3334 47.6667L45.6668 33.3333C46.1668 32.8333 46.8334 32.5 47.5001 32.3333L57.3334 30.5C58.3334 30.3333 59.5001 30.6667 60.3334 31.5L63.8334 35C64.6668 35.8333 65.0001 36.8333 64.8334 37.8333L63.1668 47.8333C63.0001 48.5 62.6668 49.1667 62.1668 49.6667L47.8334 64C46.6668 65.3333 45.1668 65.8333 43.8334 65.8333ZM59.0001 32.8333L57.8334 34L47.8334 35.8333L33.5001 50.1667C32.6668 51 32.5001 52.1667 33.1668 52.8333L42.6668 62.3333C43.0001 62.6667 43.5001 62.8333 43.8334 62.6667C44.3334 62.6667 44.8334 62.3333 45.3334 62L59.6668 47.6667L61.3334 37.6667L57.8334 34.1667L59.0001 32.8333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8337 38C54.8337 38 54.167 38.6667 54.167 39.6667C54.167 40.6667 54.8337 41.3333 55.8337 41.3333C56.8337 41.3333 57.5003 40.6667 57.5003 39.6667C57.5003 38.6667 56.8337 38 55.8337 38Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaleIlusGreen);
export default __webpack_public_path__ + "static/media/sale_ilus_green.51bd33ae556ccfcd977020e2145d5bad.svg";
export { ForwardRef as ReactComponent };